import { Theme } from '@material-ui/core';

export const nkInputSize = { height: '42px', width: '100%', padding: '0 14px' };

export const DEFAULT_INPUT_WIDTH = '256px';

export function getInputBorderColor(
  theme: Theme,
  disabled: boolean,
  hover?: boolean,
  active?: boolean,
): string {
  if (disabled) {
    return theme.palette.action.disabled;
  }
  if (hover) {
    return theme.palette.action.hover;
  }
  if (active) {
    return theme.palette.action.active;
  }

  return theme.palette.divider;
}
